import { RefundStatus, StepStatus } from '@/models/subsidy/status';

export const refundStatusMap = {
  // Resource Approval
  [RefundStatus.ResourceApprovalCanceled]: '1/5: Solicitação cancelada',
  [RefundStatus.ResourceApprovalRevisionRequired]: '1/5: Correção necessária',
  [RefundStatus.ResourceApprovalPendingApproval]: '2/5: Item em análise',
  [RefundStatus.ResourceApprovalRejected]: '2/5: Item recusado',
  [RefundStatus.ResourceApprovalApproved]: '3/5: Documentação pendente',
  [RefundStatus.ResourceApprovalNotApproved]: '2/5: Item recusado',

  // Refund Request
  [RefundStatus.RefundRequestCanceled]: '3/5: Solicitação cancelada',
  [RefundStatus.RefundRequestPendingApproval]: '4/5: Análise Galena pendente',
  [RefundStatus.RefundRequestRevisionRequired]: '4/5: Correção necessária',
  [RefundStatus.RefundRequestRejected]: '4/5: Documentação recusada',
  [RefundStatus.RefundRequestApproved]: '5/5: Pagamento pendente',
  [RefundStatus.RefundRequestPaid]: '5/5: Pagamento realizado',

  // Default
  default: 'Informação não disponível',
};

export const refundStatusColorMap: Record<RefundStatus, StepStatus> = {
  [RefundStatus.ResourceApprovalCanceled]: StepStatus.Error,
  [RefundStatus.ResourceApprovalRevisionRequired]: StepStatus.Warning,
  [RefundStatus.ResourceApprovalPendingApproval]: StepStatus.Pending,
  [RefundStatus.ResourceApprovalRejected]: StepStatus.Error,
  [RefundStatus.ResourceApprovalApproved]: StepStatus.Warning,
  [RefundStatus.ResourceApprovalNotApproved]: StepStatus.Error,
  [RefundStatus.RefundRequestCanceled]: StepStatus.Error,
  [RefundStatus.RefundRequestPendingApproval]: StepStatus.Pending,
  [RefundStatus.RefundRequestRevisionRequired]: StepStatus.Warning,
  [RefundStatus.RefundRequestRejected]: StepStatus.Error,
  [RefundStatus.RefundRequestApproved]: StepStatus.Pending,
  [RefundStatus.RefundRequestPaid]: StepStatus.Success,
};
